import Navbar from './components/Navbar';
import { Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import User from './pages/private/User';
import PrivateRoute from './pages/private/PrivateRoute';
import Relais from './pages/private/Relais';
import Consommation from './pages/private/Consommation';
import PageNotFound from './pages/PageNotFound';
import Roles from './pages/private/Roles';
import Profile from './pages/private/Profile';
import EditRoleAndPassword from './pages/private/EditRoleAndPassword';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route element={<PrivateRoute />} >
          <Route path="/" element={<Consommation />} />
          <Route path="/consommation" element={<Consommation />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/role" element={<Roles />} />
          <Route path="/relais" element={<Relais />} />
          <Route path="/user" element={<User />} />
          <Route path="/user/edit-role" element={<EditRoleAndPassword />} />
        </Route>
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/login" element={<Login />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
